// Shared filter-field classification for the Traffic feature.
// Used by the Traffic sidebar (`TrafficFilterSideMenu`), the Reports
// builder (`TrafficReportFilters`), and the filter-serializer in
// `Reports/utils.tsx`. Keep these in sync with `propertyOptions` in
// Traffic.tsx and TrafficReportFilters.tsx, and with the backend
// allow-lists in `papaya/src/api/routes/traffic/utils.ts`.

// JSONB-derived filters that translate to `storefront_data @> ...`
// containment queries. Free-text input (no finite option set to fetch).
export const FREE_TEXT_FILTER_FIELDS: Set<string> = new Set([
  'sku',
  'variant_id',
  'product_name',
])

// Numeric aggregate / range-friendly fields. Rendered as a min/max pair
// and sent to the backend as { op: 'range', value: { min, max } }.
export const RANGE_FILTER_FIELDS: Set<string> = new Set([
  'cart_value', 'total_quantity', 'max_line_price', 'min_line_price',
  'cart_value_usd', 'max_line_price_usd', 'min_line_price_usd',
])
